/**
 * This place where we put out
 * Chat definitions method
 */

export const actions = {
  initializeCurrentChannel: 'initializeCurrentChannel',
  setOwnChannels: 'setOwnChannels',
  pickChannel: 'pickChannel',
  transferChannel: 'transferChannel',
  leaveChannel: 'leaveChannel',
  joinChannel: 'joinChannel'
};

export const mutations = {
  setCurrentChannel: 'setCurrentChannel',
  setOwnChannels: 'setOwnChannels',
  insertOwnChannels: 'insertOwnChannels',
  removeOwnChannels: 'removeOwnChannels',
  updateOwnChannels: 'updateOwnChannels',
  setCurrentChannelStatus: 'setCurrentChannelStatus',
  updateCurrentChannel: 'updateCurrentChannel',
  setChannelUnread: 'setChannelUnread'
};

export default {
  actions,
  mutations
};
